import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";

import {
  Root,
  Container,
  TitleContainer,
  Subtitle,
  Title,
  Slide,
  SlideBody,
  Image,
  SlideTitle,
  Action,
} from "./Recipes.style";

import useIntersection from "../../hooks/useIntersection";
import SliderStyled from "../SliderStyled/SliderStyled";
import RecipesModal from "../RecipesModal/RecipesModal";

import { slides, sliderSettings } from "./config";

const Recipes = ({ id, onIntersected }) => {
  const ref = useRef(null);
  const isIntersected = useIntersection(ref);
  const [slide, setSlide] = useState(false);

  useEffect(() => {
    if (isIntersected) {
      onIntersected();
    }
  }, [isIntersected, onIntersected]);

  return (
    <Root ref={ref} id={id}>
      <TitleContainer>
        <Subtitle>Shine Responsibly®</Subtitle>
        <Title>Cocktail recipes</Title>
      </TitleContainer>

      <Container>
        <SliderStyled>
          <Slider {...sliderSettings}>
            {slides.map((slide, idx) => (
              <Slide key={slide.id} onClick={() => setSlide(idx)}>
                <SlideBody>
                  <SlideTitle>{slide.label}</SlideTitle>
                  <Action>See Recipe</Action>
                </SlideBody>
                <Image
                  src={slide.imageSrc}
                  alt={`Image of the ‘${slide.label}’ cocktail`}
                />
              </Slide>
            ))}
          </Slider>
        </SliderStyled>
      </Container>

      {slide !== false && (
        <RecipesModal
          slides={slides}
          initialSlide={slide}
          onClose={() => setSlide(false)}
        />
      )}
    </Root>
  );
};

export default Recipes;
